import {gsap} from "gsap";

export const runLine = () => {
    const container = document.querySelector('.footer__animated');
    if (container) {
        const items = Array.from(container.children);
        items?.forEach(item => {
            const clone = item.cloneNode(true);
            container?.appendChild(clone);
        });

        const totalWidth = items?.reduce((acc, el) => acc + el.offsetWidth, 0);
        gsap.to(container, {
            x: `-=${totalWidth}`,
            duration: 25,
            ease: "none",
            repeat: -1,
            modifiers: {
                x: gsap.utils.unitize(x => parseFloat(x) % totalWidth)
            }
        });
    }

};
